<template>
  <v-form @submit.prevent="requestSenderId" v-model="isFormValid" ref="form">
    <div class="mb-1 subtitle-2 grey3--text">Business/Institution name</div>
    <v-text-field
      v-model="business"
      placeholder="St Monica / Nile Valley Ltd"
      :rules="businessRules"
      outlined
      dense
    ></v-text-field>
    <div class="mb-1 subtitle-2 grey3--text">Preferred SenderId</div>
    <v-text-field
      v-model="senderId"
      placeholder="SenderId"
      :rules="senderIdRules"
      outlined
      dense
    ></v-text-field>
    <div class="mb-1 subtitle-2 grey3--text">Phone number</div>
    <v-text-field
      v-model="phone"
      placeholder="07xxxxxxxx"
      :rules="phoneNumberRules"
      outlined
      dense
    ></v-text-field>
    <v-btn
      class="mt-2 primary white--text lowercase-text"
      block
      plain
      :loading="$store.state.loading.senderIdRequestBtn.load"
      :disabled="$store.state.loading.senderIdRequestBtn.disabled"
      type="submit"
    >
      Request SenderId
    </v-btn></v-form
  >
</template>

<script>
export default {
  data() {
    return {
      business: "",
      senderId: "",
      phone: "",
      isFormValid: false,
      businessRules: [
        (v) => !!v || "Business name is required",
        (v) =>
          (v && v.length >= 3) ||
          "Business name  must be at least 3 characters",
      ],
      senderIdRules: [
        (v) => !!v || "SenderId is required",
        (v) => (v && v.length >= 3) || "SenderId must be at least 3 characters",
      ],
      phoneNumberRules: [
        (v) => !!v || "Phone number is required",
        (v) => /^[0-9]{10}$/.test(v) || "Phone number must be 10 digits",
      ],
    };
  },
  computed: {
    receivedUser() {
      return this.$store.getters.getUser;
    },
  },
  methods: {
    async requestSenderId() {
      if (this.$refs.form.validate()) {
        // Form is valid, perform form submission or other actions
        await this.$store.dispatch("senderids/requestSenderId", {
          business: this.business,
          senderId: this.senderId,
          phone: this.phone,
        });
      }
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
</style>
